export class ClosePopup {
  constructor() {
    this.close()
  }

  private close() {
    const closeBtn = document.querySelector('.popup__close') as HTMLElement
    const popup = document.querySelector('.popup') as HTMLElement

    if (closeBtn && popup) {
      closeBtn.addEventListener('click', () => {
        popup.classList.add('hidden')
      })
    }
  }
}
